import React from 'react';
import { Plus, Search } from 'lucide-react';
import API_BASE from '../../../../utils/api.js';

const proxyImg = (url) =>
  url ? `${API_BASE}/api/upload/proxy-image?url=${encodeURIComponent(url)}` : '';

export default function CatalogSection({
  catalog,
  q,
  setQ,
  selectedType,
  setSelectedType,
  catalogLoading,
  catalogError,
  addItemFromCatalog,
  setShowAddItemModal,
  fmtUSD,
}) {
  const normalizedQuery = String(q || '').trim().toLowerCase();
  const filteredCatalog = (Array.isArray(catalog) ? catalog : []).filter((item) => {
    const typeMatch = !selectedType || String(item?.type || '').toLowerCase() === selectedType;
    if (!typeMatch) return false;
    if (!normalizedQuery) return true;

    const haystack = [
      item?.name,
      item?.description,
      item?.category,
      item?.vendorName,
      item?.type,
      item?.salesCode,
    ]
      .map((value) => String(value || '').toLowerCase())
      .join(' ');

    return haystack.includes(normalizedQuery);
  });

  return (
    <div className="catalog-section">
      <div className="catalog-header">
        <h3>Add Items from Catalog</h3>
        <div className="catalog-controls">
          <select
            className="if-select"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="">All Types</option>
            <option value="product">Products</option>
            <option value="service">Services</option>
          </select>

          <button className="if-btn-primary" onClick={() => setShowAddItemModal(true)}>
            + Add New
          </button>
        </div>
      </div>

      <div className="catalog-search">
        <Search size={16} />
        <input
          className="if-input"
          placeholder="Search name, vendor, category, description..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      <div className="catalog-grid">
        {catalogLoading ? (
          <div className="muted">Loading...</div>
        ) : catalogError ? (
          <div className="po-error">{catalogError}</div>
        ) : filteredCatalog.length === 0 ? (
          <div className="muted">No matching catalog items.</div>
        ) : (
          filteredCatalog.map((it) => (
            <button
              key={it.itemId}
              className="catalog-card"
              onClick={() => addItemFromCatalog(it)}
              title={`${it?.name || 'Item'}${it?.vendorName ? ` - ${it.vendorName}` : ''}`}
            >
              <div
                className="thumb"
                style={{
                  backgroundImage: it.imageUrl ? `url(${proxyImg(it.imageUrl)})` : 'none',
                }}
              />
              <div className="name">{it?.name || 'Untitled Item'}</div>
              <div className="price">{fmtUSD(Number(it?.tradePrice || 0))}</div>

              <span className="add">
                <Plus size={14} />
              </span>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
